/* eslint-disable @nx/enforce-module-boundaries */
import { useState, useContext, useEffect } from 'react';
import { FolderIcon, SharedDisksIcon, TeamNewIcon } from '@mybridge/icons';
import { Avatar, Heading, List, Stack, Text } from '@mybridge/ui';
import { getProfilePic, getUserFullName, toPascalCase } from 'v4/lib/commons';
import { DiskContext } from '../../context';
import {
  DiskMenuItem,
  DiskMenuItemIcon,
  DiskTypeMenuItem,
  DiskTypeMenuItemIcon,
} from '../main-menu-item';
import { RootDirIcon } from './root-dir-icon';
import { isMobile } from 'react-device-detect';
import { useRouter } from 'next/router';
import axios from 'axios';
import { TeamsContext } from 'v4/snippets/teams/context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { getTeamDetailById } from 'v4/store/actions/teamCommunity.actions';
import { useDispatch, useSelector } from 'react-redux';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
import { getFolderDetails } from 'v4/store/actions/myDisk.Action';
import { useToast } from '@mybridge/ui';

export const MyDiskMenu = () => {
  const {
    rootDirs,
    sharedDiskUsers,
    selectedMainDirType,
    selectedMainDir,
    selectedSharedDiskUser,
    setSelectedMainDir,
    setSelectedSharedDiskUser,
    setSelectedMainDirType,
    setHistory,
    setSelectedFiles,
    teamDirs,
    selectRootDir,
    selectTeamDir,
    selectSharedDiskUser,
    selectDiskType,
    mobileFilePanelDisc,
    // setSelectedDir is used for deep-link folderId navigation
    setSelectedDir,
  } = useContext(DiskContext);
  const {

    setChatTeamSlug,
    refetchTeamOrganizers
  } = useContext(TeamsContext);
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const direction = useDirection();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const toast = useToast();
const userSlug = userProfileInfo?.slug || 'anonymous';

  // State to manage expanded section
  const [expandedSection, setExpandedSection] = useState('my-disk'); // 'my-disk' is default
const router=useRouter()
  // Handler to toggle sections
  const handleToggleSection = (section) => {
    setExpandedSection((prevSection) => (prevSection === section ? null : section));
  };

  const getUserSlug = () => {
    return userProfileInfo?.slug || userProfileInfo?.username || null;
  };

  const trackSharedDisk = () => {
    const userSlug = getUserSlug();
    if (!userSlug) return;

    trackEvent(ANALYTICS_EVENTS.ShareDisk, userSlug, {
      device_type: isMobile ? 'mobile' : 'desktop',
      timestamp: new Date().toISOString()
    })
  };
  
  useEffect(()=>{
    if(router?.query?.team){
      let selectedTeam=teamDirs?.filter((team)=>team?.team_ref==router?.query?.team)
      setTimeout(()=>{
        if (isMobile) mobileFilePanelDisc?.onOpen();
        else handleToggleSection('team-disk')
        setExpandedSection('team-disk')
        selectDiskType('team-disk');
        selectTeamDir(...selectedTeam)
        handleGetTeamDetails(selectedTeam?.[0]?.team_ref)
      },1000)
      
    }

     // SHARED DISK
    if (router?.query?.shared) {
      let selectedUser = sharedDiskUsers?.find(
        (user) => user?.id == router?.query?.shared
      );
      setTimeout(() => {
        if (isMobile) mobileFilePanelDisc?.onOpen();
        else handleToggleSection('shared-disk');
        setExpandedSection('shared-disk');
        selectDiskType('shared-disk');
        if (selectedUser) {
          selectSharedDiskUser(selectedUser);
        }
      }, 1000);
    }

    // DEEP LINK HANDLER
    if (router?.query?.folderId) {
      const folderId = parseInt(router?.query?.folderId, 10);
      if (!isNaN(folderId)) {
        dispatch(getFolderDetails(folderId)).then((res) => {
          const folder = res?.payload;
          if (folder && !folder.detail) {
            const isOwner = folder.owner?.id === userProfileInfo?.id;
            const isShared = folder.shared_with?.some(m => m.id === userProfileInfo?.id || m === userProfileInfo?.id);
            if (isOwner || isShared) {
              setTimeout(() => {
                if (isMobile) mobileFilePanelDisc?.onOpen();
                else handleToggleSection('my-disk');
                setExpandedSection('my-disk');
                selectDiskType('my-disk');
                setSelectedMainDir(folder);
                // Clean the URL to remove folderId and tracking params using replace to keep history clean
                router.replace({ pathname: router.pathname }, undefined, { shallow: true });
              }, 500);
            }
          }
        });
      }
    }
}, [teamDirs, sharedDiskUsers, router?.query]);

  // const handleGetTeamDetails = (id) => {
  //   // axios.get(`https://api.bybk.org/api/v1/team/${id}/`)
  //   dispatch(getTeamDetailById(id))
  //   .then((res) => {
  //     console.log(res?.data?.slug, "resssssssss");
  //     setChatTeamSlug(res?.data?.slug);
  //     console.log(res?.data,"fkkoe");
  //     const teamId = res?.data?.id;
  //     // Use refetch with the team ID
  //     refetchTeamOrganizers({ queryKey: ['team-organizers',teamId] });
  //   });
  // };

  const handleGetTeamDetails = (id) => {
    dispatch(getTeamDetailById(id)).then((res) => {
      const teamData = res?.payload;
      setChatTeamSlug(teamData?.slug);
      const teamId = teamData?.id;
      // Use refetch with the team ID
      refetchTeamOrganizers({ queryKey: ['team-organizers', teamId] });
    });
  };
  
  return (
    <Stack px={[2, 0]} bg="white">
      {/* Root dirs */}
      {rootDirs?.length ? (
        <DiskTypeMenuItem
          bg={selectedMainDirType === 'my-disk' ? 'brandGray.500' : ''}
          onClick={() => {
            selectDiskType('my-disk');
            if (isMobile) mobileFilePanelDisc?.onOpen();
            else handleToggleSection('my-disk');
          }}
        >
          <DiskTypeMenuItemIcon>
            <FolderIcon color="white" height={isMobile ? '16' : '24'} width={isMobile ? '16' : '24'} />
          </DiskTypeMenuItemIcon>
          <Heading size="sm" fontWeight="400">
            {t('myDisk.myDisk') || "My Disk"}
          </Heading>
        </DiskTypeMenuItem>
      ) : null}

      {/* Conditionally render rootDirs list */}
      {rootDirs?.length && expandedSection === 'my-disk' && !isMobile ? (
        <List as={Stack} pl={6}>
          {rootDirs?.map((dir, dirIndex) => (
            <DiskMenuItem
              key={dirIndex}
              onClick={() => {
                selectRootDir(dir);
                 try {
                    trackEvent(ANALYTICS_EVENTS.MyDiskDetail, userSlug, {
                      dirId: dir?.id || 'unknown',
                      dirName: dir?.display_name || 'unknown',
                      timestamp: new Date().toISOString(),
                    });
                  } catch (err) {
                    console.error('Failed to log MyDiskDetail event:', err);
                  }
                if (isMobile) mobileFilePanelDisc?.onOpen();
              }}
              bg={selectedMainDir?.id === dir?.id ? 'brandGray.500' : ''}
            >
              <DiskMenuItemIcon>
                <RootDirIcon dir={dir} width={18} height={18} />
              </DiskMenuItemIcon>
              <Text sx={{direction: 'ltr'}} truncate maxW="48" title={t(`myDisk.${dir?.name}`) || toPascalCase?.(dir?.display_name)}>
                {t(`myDisk.${dir?.name}`) || toPascalCase?.(dir?.display_name)}
              </Text>
            </DiskMenuItem>
          ))}
        </List>
      ) : null}

      {/* Shared dirs */}
      {sharedDiskUsers?.length ? (
        <DiskTypeMenuItem
          bg={selectedMainDirType === 'shared-disk' ? 'brandGray.500' : ''}
          onClick={() => {
            trackSharedDisk();
            selectDiskType('shared-disk');
            if (isMobile) mobileFilePanelDisc?.onOpen();
            else handleToggleSection('shared-disk');
          }}
        >
          <DiskTypeMenuItemIcon>
            <SharedDisksIcon color="white" height={isMobile ? '16' : '24'} width={isMobile ? '16' : '24'} />
          </DiskTypeMenuItemIcon>
          <Heading size="sm" fontWeight="400">
            {t('myDisk.sharedDisks') || "Shared Disks"}
          </Heading>
        </DiskTypeMenuItem>
      ) : null}

      {/* Conditionally render sharedDiskUsers list */}
      {sharedDiskUsers?.length && expandedSection === 'shared-disk' && !isMobile ? (
       <List as={Stack} pl={6}>
          {[...sharedDiskUsers]?.reverse().map((user, userIndex) => (
            <DiskMenuItem
              key={userIndex}
              onClick={() => {
                selectSharedDiskUser(user);
                if (isMobile) mobileFilePanelDisc?.onOpen();
              }}
              bg={selectedSharedDiskUser?.id === user?.id ? 'brandGray.500' : ''}
            >
              <DiskMenuItemIcon>
                <Avatar size="sm" name={getUserFullName(user)} src={user?.profile_pic} />
              </DiskMenuItemIcon>
              <Text sx={{direction: 'ltr'}} truncate maxW="48">
                {toPascalCase?.(getUserFullName(user))}
              </Text>
            </DiskMenuItem>
          ))}
        </List>
      ) : null}

      {/* Team dirs */}
      {teamDirs?.length ? (
        <DiskTypeMenuItem
          bg={selectedMainDirType === 'team-disk' ? 'brandGray.500' : ''}
          onClick={() => {
            selectDiskType('team-disk');
            if (isMobile) mobileFilePanelDisc?.onOpen();
            else handleToggleSection('team-disk');
          }}
        >
          <DiskTypeMenuItemIcon>
            <TeamNewIcon color="white" height={isMobile ? '16' : '24'} width={isMobile ? '16' : '24'} />
          </DiskTypeMenuItemIcon>
          <Heading size="sm" fontWeight="400">
            {t('myDisk.teamDisks') || "Team Disks"}
          </Heading>
        </DiskTypeMenuItem>
      ) : null} 

      {/* Conditionally render teamDirs list */}
      {teamDirs?.length && expandedSection === 'team-disk' && !isMobile ? (
        <List
        __css={{
          "@media (min-width: 768px) and (max-width: 1023px)": {
            height: "350px",
          },
          "@media (min-width: 1024px) and (max-width: 1439px)": {
            height: "310px",
          },
          "@media (min-width: 1440px) and (max-width: 1535px)": {
            height: "215px",
          },
          "@media (min-width: 1536px) and (max-width: 1919px)": {
            height: "275px",
          },
          "@media (min-width: 1920px) and (max-width: 2560px)": {
            height: "280px",
          },
        }}
        overflow={!isMobile && "auto"}
        as={Stack}
        pl={6}>
          {teamDirs?.map((dir, dirIndex) => (
            <DiskMenuItem
              key={dirIndex}
              onClick={() => {
                handleGetTeamDetails(dir?.team_ref)
                selectTeamDir(dir);
                if (isMobile) mobileFilePanelDisc?.onOpen();
              }}
              bg={selectedMainDir?.id === dir?.id ? 'brandGray.500' : ''}
            >
              <Avatar size="sm" name={dir?.team_info?.name} src={getProfilePic(dir?.team_info)} />
              <Text sx={{direction: 'ltr'}} truncate maxW="48" title={toPascalCase?.(dir?.team_info?.name)}>
                {toPascalCase?.(dir?.team_info?.name)}
              </Text>
            </DiskMenuItem>
          ))}
        </List>
      ) : null}
    </Stack>
  );
};

